export default {
    states: {
        NONE: 'NONE',
        DATA: 'DATA',
        NO_DATA: 'NO_DATA',
        LOADING: 'LOADING'
    },
    modes: {
        SETUP: 'SETUP',
        DATA: 'DATA'
    },
    tools: {
        FLOOR_GENERAL: 'FLOOR_GENERAL',
        FLOOR: 'FLOOR',
        SENSOR: 'SENSOR',
        ZONE: 'ZONE',
        FURNITURE: 'FURNITURE',
        NONE: 'NONE'
    },
    actions: {
        PLACE_SENSOR: 'PLACE_SENSOR',
        REMOVE_SENSOR: 'REMOVE_SENSOR',
        MARK_SENSOR: 'MARK_SENSOR',
        UNMARK_ALL_SENSORS: 'UNMARK_ALL_SENSORS',
        SENSOR_PLACED: 'SENSOR_PLACED',
        SENSOR_REMOVED: 'SENSOR_REMOVED',
        OUTER_WALL_CLOSED: 'OUTER_WALL_CLOSED',
        SENSOR_MARKED: 'SENSOR_MARKED',
        SAVE: 'SAVE',
        FLOOR_SELECT: 'FLOOR_SELECT',
        TOOL_SELECT: 'TOOL_SELECT',
        MODE_SELECT: 'MODE_SELECT',
        WALL_SELECT: 'WALL_SELECT',
        SENSOR_DATA: 'SENSOR_DATA',
        ZONE_DATA: 'ZONE_DATA',
        WALL_DESELECT: 'WALL_DESELECT',
        DESELECT_ALL_WALLS: 'DESELECT_ALL_WALLS',
        ADD_OUTER_WALL: 'ADD_OUTER_WALL',
        ADD_INNER_WALL: 'ADD_INNER_WALL',
        COMPLETE_INNER_WALL: 'COMPLETE_INNER_WALL',
        DELETE_WALL: 'DELETE_WALL',
        SET_DISPLAY_METHOD: 'SET_DISPLAY_METHOD',
        PLACE_ZONE: 'PLACE_ZONE',
        REMOVE_ZONE: 'REMOVE_ZONE',
        ZONE_PLACED: 'ZONE_PLACED',
        ZONE_REMOVED: 'ZONE_REMOVED',
        ZONE_SELECT: 'ZONE_SELECT',
        DESELECT_ALL_ZONES: 'DESELECT_ALL_ZONES',
        ADD_FURNITURE: 'ADD_FURNITURE',
        REMOVE_FURNITURE: 'REMOVE_FURNITURE',
        SHOW_SENSOR_INFO: 'SHOW_SENSOR_INFO',
        SET_DATA_MODE: 'SET_DATA_MODE',
        SET_DATA_TYPE: 'SET_DATA_TYPE',
        GET_OUTER_WALL: 'GET_OUTER_WALL',
        CANVAS_CLEANUP: 'CANVAS_CLEANUP'
    },
    elementTypes: {
        SENSOR: 'SENSOR',
        WALL: 'WALL',
        ZONE: 'ZONE',
        OUTERWALL: 'OUTERWALL',
        INNERWALL: 'INNERWALL',
        FURNITURE: 'FURNITURE'
    }, 
    elementStates: {
        PLACED: 'PLACED',
        PLACING: 'PLACING',
        NOT_PLACED: 'NOT_PLACED'
    },
    displayMethods: {
        CONTINUOUS: 'CONTINUOUS',
        SIMPLE: 'SIMPLE'
    }, 
    dataModes: {
        LIVE: 'LIVE',
        HISTORY: 'HISTORY',
        TREND: 'TREND'
    },
    dataTypes: {
        AVG_DB: 'AVG_DB',
        AVG_DIFF_DB: 'AVG_DIFF_DB',
        AVG_FIL_DB: 'AVG_FIL_DB'
    },
    dataIntervals: {
        LAST_15_MINUTES: 'LAST_15_MINUTES',
        LAST_4_HOURS: 'LAST_4_HOURS',
        LAST_24_HOURS: 'LAST_24_HOURS'
    },
    heatmapTypes: {
        MINI: 'MINI'
    }
}